'use strict'

export const MEDIA = {
  tv: '(min-width: 2780px)',

  light: '(prefers-color-scheme: light)',
  dark: '(prefers-color-scheme: dark)',

  print: 'print'
}
